import React from "react";
import { Offcanvas } from "react-bootstrap";

const PrenotazioneInfoOffcanvas = ({
    showInfo,
    handleCloseInfo,
    setShowInfo,
    setShowUpdate,
    giorno,
    nome_tappa_inizio,
    nome_tappa_fine,
    id_cammino,
    id_utente,
    data_prenotata,
    totale,
    stato_prenotazione,
    bagagli,
    id_alloggio_inizio,
    id_alloggio_fine,
    tracking_link_pickup,
    tracking_link_delivery,
}) => {
    const handleSwitchToUpdate = () => {
        setShowInfo(false);
        setShowUpdate(true);
    };

    return (
        <Offcanvas
            className="offcanvas-custom"
            placement="end"
            show={showInfo}
            onHide={handleCloseInfo}
        >
            <Offcanvas.Header>
                <img
                    onClick={handleCloseInfo}
                    className="btn-close-img"
                    src="/closeBtn.svg"
                />
                <p
                    style={{
                        color: "#B1B1B1",
                        fontSize: "2em",
                        marginBottom: "0",
                        position: "absolute",
                        left: "60px",
                    }}
                >
                    Prenotazioni - Info
                </p>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div>
                    <div>
                        <div>
                            <div style={{ paddingLeft: "30px", paddingRight: "30px" }}>
                                <div
                                    style={{ bottom: "50px", left: "30px", textAlign: "right" }}
                                >
                                    <img
                                        onClick={handleSwitchToUpdate}
                                        style={{
                                            display: "inline-block",
                                            cursor: "pointer",
                                            width: "40px",
                                        }}
                                        src="/updateTable.svg"
                                    />
                                </div>
                                <div className="mb-2">
                                    <h2
                                        style={{
                                            color: "#B1B1B1",
                                            fontSize: "1.5em",
                                            fontWeight: "300",
                                        }}
                                    >
                                        {giorno}
                                    </h2>
                                    <h2
                                        style={{
                                            color: "#2F2F2F",
                                            fontSize: "1.5em",
                                            fontWeight: "600",
                                            marginBottom: "20px",
                                        }}
                                    >
                                        {nome_tappa_inizio} - {nome_tappa_fine}
                                    </h2>
                                </div>

                                <div className="md-form mb-2">
                                    <i className="fas fa-user prefix grey-text"></i>
                                    <b>Id Prenotazione</b>
                                    <p>{id_cammino}</p>
                                </div>

                                <div className="md-form mb-2">
                                    <i className="fas fa-user prefix grey-text"></i>
                                    <b>Id utente</b>
                                    <p>{id_utente}</p>
                                </div>

                                <div className="md-form mb-2">
                                    <i className="fas fa-user prefix grey-text"></i>
                                    <b>Data Prenotata</b>
                                    <p>{data_prenotata && new Date(data_prenotata).toLocaleDateString()}</p>
                                </div>

                                <div className="md-form mb-2">
                                    <i className="fas fa-user prefix grey-text"></i>
                                    <b>Totale Prenotazione</b>
                                    <p>{totale}</p>
                                </div>
                                <div className="md-form mb-2">
                                    <i className="fas fa-user prefix grey-text"></i>
                                    <b>Stato Prenotazione</b>
                                    <p>{stato_prenotazione}</p>
                                </div>
                                <div className="md-form mb-2">
                                    <i className="fas fa-user prefix grey-text"></i>
                                    <b>Nº Bagagli</b>
                                    <p>{bagagli}</p>
                                </div>

                                <div className="md-form mb-2">
                                    <i className="fas fa-user prefix grey-text"></i>
                                    <b>Partenza</b>
                                    <p>{nome_tappa_inizio}</p>
                                </div>

                                <div className="md-form mb-2">
                                    <i className="fas fa-user prefix grey-text"></i>
                                    <b>Arrivo</b>
                                    <p>{nome_tappa_fine}</p>
                                </div>

                                <div className="md-form mb-2">
                                    <i className="fas fa-user prefix grey-text"></i>
                                    <b>Alloggio di Partenza</b>
                                    <p style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        {typeof id_alloggio_inizio === 'object' ? id_alloggio_inizio.nome : id_alloggio_inizio}
                                        {typeof id_alloggio_inizio === 'object' && id_alloggio_inizio.attivo !== 0 && (
                                            <span
                                                style={{
                                                    display: "inline-block",
                                                    width: "10px",
                                                    height: "10px",
                                                    borderRadius: "50%",
                                                    backgroundColor: "#FF9D00",
                                                    marginLeft: "4px"
                                                }}
                                                title="Struttura da confermare"
                                            />
                                        )}
                                    </p>
                                </div>
                                <div className="md-form mb-2">
                                    <i className="fas fa-user prefix grey-text"></i>
                                    <b>Alloggio di Arrivo</b>
                                    <p style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        {typeof id_alloggio_fine === 'object' ? id_alloggio_fine.nome : id_alloggio_fine}
                                        {typeof id_alloggio_fine === 'object' && id_alloggio_fine.attivo !== 0 && (
                                            <span
                                                style={{
                                                    display: "inline-block",
                                                    width: "10px",
                                                    height: "10px",
                                                    borderRadius: "50%",
                                                    backgroundColor: "#FF9D00",
                                                    marginLeft: "4px"
                                                }}
                                                title="Struttura da confermare"
                                            />
                                        )}
                                    </p>
                                </div>

                                {/* Tracking Section */}
                                {(tracking_link_pickup || tracking_link_delivery) && (
                                    <div style={{
                                        marginTop: "30px",
                                        paddingTop: "20px",
                                        borderTop: "1px solid #E0E0E0"
                                    }}>
                                        <h3 style={{
                                            color: "#2F2F2F",
                                            fontSize: "1.3em",
                                            fontWeight: "600",
                                            marginBottom: "15px"
                                        }}>
                                            Tracking Bagagli
                                        </h3>
                                        <div style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "12px"
                                        }}>
                                            {tracking_link_pickup && (
                                                <a
                                                    href={tracking_link_pickup}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        backgroundColor: "#FF9D00",
                                                        color: "white",
                                                        padding: "12px 20px",
                                                        borderRadius: "12px",
                                                        textDecoration: "none",
                                                        fontSize: "1em",
                                                        fontWeight: "600",
                                                        transition: "all 0.2s",
                                                        border: "none",
                                                        cursor: "pointer"
                                                    }}
                                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#E68D00"}
                                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#FF9D00"}
                                                >
                                                    <span style={{ marginRight: "8px", fontSize: "1.2em" }}>📦</span>
                                                    Traccia Ritiro Bagagli
                                                </a>
                                            )}
                                            {tracking_link_delivery && (
                                                <a
                                                    href={tracking_link_delivery}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        backgroundColor: "#5552f3",
                                                        color: "white",
                                                        padding: "12px 20px",
                                                        borderRadius: "12px",
                                                        textDecoration: "none",
                                                        fontSize: "1em",
                                                        fontWeight: "600",
                                                        transition: "all 0.2s",
                                                        border: "none",
                                                        cursor: "pointer"
                                                    }}
                                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#4441d9"}
                                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#5552f3"}
                                                >
                                                    <span style={{ marginRight: "8px", fontSize: "1.2em" }}>🚚</span>
                                                    Traccia Consegna Bagagli
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default PrenotazioneInfoOffcanvas;